<template>
  <div>
    <template v-if="rating">
      <div class="rating">{{ (Math.round(ratingData * 10) / 10).toFixed(1) }}</div>
    </template>
    <div class="star-rating">
      <i class="fa" :class="starClass(0)" aria-hidden="true"></i>
      <i class="fa" :class="starClass(1)" aria-hidden="true"></i>
      <i class="fa" :class="starClass(2)" aria-hidden="true"></i>
      <i class="fa" :class="starClass(3)" aria-hidden="true"></i>
      <i class="fa" :class="starClass(4)" aria-hidden="true"></i>
    </div>
    <slot/>
  </div>
</template>
<script>
export default {
    data(){
        return{
            ratingData: Number(this.rating) * 5,
        }
    },
    props:{
        ratingCount: {default: null},
        rating: {default: 0},
    },
    methods:{
        starClass(starIndex){
            if (this.ratingData < (starIndex + 0.25)) {
                return 'fa-star-o'
            }
            if (this.ratingData >= (starIndex + 0.25) && this.ratingData <= (starIndex + 0.75)) {
                return 'fa-star-half-o'
            }
            return 'fa-star'
        }
    },
    watch: {
        'rating' () {
            this.ratingData = Number(this.rating) * 5;
        }
    },
}
</script>
<style scoped>

.fa-star::before {
    content: "";
}
.doc-status {
    align-items: center;
    -moz-column-gap: 4px;
    column-gap: 4px;
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-end;
    min-width: 140px;
    row-gap: 8px
}


.doc-status .rating {
    color: #13a546;
    font-size: 18px;
    font-weight: 600;
    order: 2
}

.doc-status .star-rating {
    display: flex;
    gap: 2px;
    order: 1
}

.doc-status .star-rating .fa {
    display: block;
    height: 18.72px;
    width: 18.72px
}

.doc-status .star-rating .fa-star {
    background: url(https://doctu.ru/img/icons/clarity_star-solid.svg) 50% no-repeat
}

.doc-status .star-rating .fa-star-half-o {
    background: url(https://doctu.ru/img/icons/clarity_half-star-solid.svg) 50% no-repeat
}

.doc-status .star-rating .fa-star-o {
    background: url(https://doctu.ru/img/icons/clarity_star-solid-empty.svg) 50% no-repeat
}

.doc-status .reviews {
    flex: 0 0 100%;
    order: 3;
    text-align: right
}

.doc-status .reviews .doctorReview {
    color: #9896ae;
    font-weight: 600;
    position: relative;
    transition: .1s ease
}

.doc-status .reviews .doctorReview:after {
    background: #9896ae;
    bottom: 0;
    content: "";
    height: 1px;
    left: 0;
    position: absolute;
    transition: .1s ease;
    width: 100%
}

.doc-status .reviews .doctorReview:hover {
    color: #13a546
}

.doc-status .reviews .doctorReview:hover:after {
    background: transparent
}

.doc-status.doc-status-oneline {
    justify-content: flex-start
}

.doc-status.doc-status-oneline .rating {
    margin-right: 6px
}

.doc-status.doc-status-oneline .reviews {
    flex: initial
}

</style>
